import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "emailField", "emailConfirmationField"]

  connect() {
    this._onKeydown = (event) => {
      if (!this.hasModalTarget) return
      if (event.key === "Escape" && this.modalTarget.style.display !== "none") this.hide()
    }
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
    document.body.style.overflow = ""
  }

  show(event) {
    event?.preventDefault()
    this.modalTarget.style.display = "flex"
    document.body.style.overflow = "hidden"

    if (this.hasEmailFieldTarget) {
      setTimeout(() => {
        this.emailFieldTarget.focus()
        this.emailFieldTarget.select()
      }, 50)
    }
  }

  hide(event) {
    event?.preventDefault()
    this.modalTarget.style.display = "none"
    document.body.style.overflow = ""
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  syncConfirmation() {
    if (this.hasEmailFieldTarget && this.hasEmailConfirmationFieldTarget) {
      this.emailConfirmationFieldTarget.value = this.emailFieldTarget.value
    }
  }
}
